import {
  ActivitiesList,
  ActivityList,
  ParsedActivityList,
  ParsedActivitiesList,
} from './types';

import { format } from 'date-fns';

const parse = (item: ActivityList): Readonly<ParsedActivityList> =>
  Object.freeze({
    orderId: item!.id || '',
    activity_id: item!.activity_id || '',
    status: parseStatus(item!.state),
    img: item!.image_url
      ? {
          small: item.image_url,
        }
      : { small: '' },
    title: item.activity_name || '',
    date: item.date ? format(item.date, 'DD.MM.YYYY') : '',
    fio: item!.user || '',
    userCanCancel: item.user_can_cancel,
    id: '',
    message:
      item.state_reason === '3' && item.state_reason_comment
        ? item.state_reason_comment
        : '',
  });

const parseStatus = (status: string): string => {
  let statusToRetutn = '';
  if (status === 'pause') {
    statusToRetutn = 'paused';
  }
  if (status === 'approve') {
    statusToRetutn = 'approved';
  }
  if (status === 'cancel') {
    statusToRetutn = 'cancelled';
  }
  if (status === 'initial') {
    statusToRetutn = status;
  }
  return statusToRetutn;
};

const parseActivities = (data: ActivitiesList): ParsedActivitiesList =>
  data.map(parse);

export default parseActivities;



// WEBPACK FOOTER //
// ./src/services/api/activities/utils/parseActivitiesOrder.ts